/** Append cache-buster for tenant static assets (nginx serves /tenants/* with long immutable TTL). */
export function tenantAssetUrl(path: string, version?: number | null): string {
  if (!path.startsWith("/tenants/")) {
    return path;
  }
  if (!version || version <= 0) {
    return path;
  }
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}v=${version}`;
}
